<script>
import Modal from "@/components/_Shared/Modal";
import InputGroup from "@/components/_Shared/InputGroup";
import vDialog from "@/components/_Shared/Dialog";
import SuccessDialog from "@/components/Freshdesk/Success/Success";
import moment from "moment";
import formatterDocumentId from "@/utils/formatters/documentId";

import freshdeskMixin from "@/mixins/freshdeskMixin";
import { mapActions } from "vuex";

export default {
  mixins: [freshdeskMixin],
  props: {
    order: Object,
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      successDialogVisibility: false,
      why: "",
      bank: "",
      agency: "",
      accountNumberWithDigit: "",
      requiredData: false,
      paymentType: "",
      firstStep: true,
      lastStep: false,
      loader: false,
      disableSendTicketButton: false
    };
  },
  components: {
    Modal,
    vDialog,
    InputGroup,
    SuccessDialog
  },
  methods: {
    ...mapActions("freshdesk", ["createCancellationTicket", "setAbsence"]),
    getDocumentType() {
      return this.order.customer_type === "Physical"
        ? "CPF " + formatterDocumentId.formatCPF(this.order.customer.cpf) + " :"
        : "CNPJ " +
            formatterDocumentId.formatCNPJ(this.order.customer.cnpj) +
            " :";
    },
    changeWhyText(val) {
      this.why = val;
    },
    hiddenFirstStep() {
      this.firstStep = false;
    },
    showLastStep() {
      this.lastStep = true;
    },
    closeSuccessDialog() {
      this.successDialogVisibility = false;
    },
    closeCancellationDialog() {
      this.$emit("close");
    },
    setTicketTags(order) {
      this.setCustomerTypeTag(order);
      this.setAdvanceTimeTag(order);
      this.isAbsenceTicket();
    },
    async submit() {
      if (
        this.paymentType === "Boleto" &&
        (this.bank == "" ||
          this.agency == "" ||
          this.accountNumberWithDigit == "")
      ) {
        this.requiredData = true;
        return;
      }
      if (this.disableSendTicketButton) return;
      this.disableSendTicketButton = true;
      this.loader = true;
      this.setTicketTags(this.order);
      this.setAbsence(true);
      try {
        let payload = {
          order: this.order,
          Data: this.$data,
          tags: this.ticketTags
        };
        await this.createCancellationTicket(payload);
        this.successDialogVisibility = true;
        this.loader = false;
      } catch (e) {
        this.disableSendTicketButton = false;
        this.loader = false;
        this.$toasted.error(e);
      }
    }
  },
  mounted() {
    if (this.order.payments.length != 0) {
      let payment = this.order.payments[0].funding_instrument;
      if (payment.type == "boletos") {
        this.paymentType = "Boleto";
      } else {
        this.paymentType = "Cartão de crédito";
      }
    } else {
      this.paymentType = "Assinatura/Cortesia";
    }
  },
  updated() {
    if (this.bank && this.agency && this.accountNumberWithDigit) {
      this.requiredData = false;
    }
  }
};
</script>
<template>
  <div>
    <modal
      title="COMUNICAR FALTA DE PROFISSIONAL"
      size="md"
    >
      <template slot="body">
        <form @submit.prevent="submit">
          <div v-if="firstStep">
            <textarea
                placeholder="Conte-nos aqui por que você deseja cancelar..."
                rows="5"
                v-model="why"
                > 
            </textarea>
          <base-flex class="mt-25">
            <div class="btn bg-purple-outline" @click="$emit('back')">voltar</div>
            <div class="btn bg-purple-outline" @click="$emit('close')">cancelar</div>
            <div v-if="isABoletoPayment(paymentType)" class="btn bg-purple" type="submit" @click="hiddenFirstStep(); showLastStep()">avançar</div>
            <div v-if="!isABoletoPayment(paymentType)" 
            class="btn bg-purple" 
            type="submit" 
            :class="{'btn--loading': loader}" 
            :disabled="disableSendTicketButton"
            @click="submit()">{{ !loader ? "solicitar cancelamento" : "" }}
            </div>
          </base-flex>
          </div>
          <div v-if="lastStep">
            <p class="bankDetails">
            Para agilizar o reembolso do seu cancelamento, 
            como o pagamento foi feito via boleto bancário, 
            precisamos dos dados de uma conta bancária vinculado ao <b>{{getDocumentType()}}</b>
            </p>
          
          <div class="form-group">
            <div>
          <InputGroup
            :error="errors.first('nome do banco')"
            v-validate="'required'"
            v-model="bank"
            name="bank"
            label="nome do banco"
          />
          </div>
          <div>
          <InputGroup
            :error="errors.first('agência')"
            v-validate="'required'"
            v-model="agency"
            name="agency"
            label="agência"
          />
          <InputGroup
            :error="errors.first('número da conta com dígito')"
            v-validate="'required'"
            v-model="accountNumberWithDigit"
            name="accountNumberWithDigit"
            label="número da conta com dígito"
          />
          </div>
          </div>
            <div 
              class="requiredWarning"
              v-if="requiredData">
              <p>Por favor, preencha os campos com os dados bancarios.</p>
            </div>
            <base-flex class="mt-30">
              <div class="btn bg-purple-outline" @click="$emit('close')">cancelar</div>
              <div class="btn bg-purple" 
                type="submit" 
                :class="{'btn--loading': loader}" 
                :disabled="disableSendTicketButton"
                @click="submit()">{{ !loader ? "solicitar cancelamento" : "" }}
              </div>
          </base-flex>
          </div>
        </form>
      </template>
    </modal>
    <success-dialog 
      :visible="successDialogVisibility"
      @close="closeSuccessDialog(); closeCancellationDialog()"
    />
  </div>
</template>

<style lang="scss" scoped>
.form-group {
  @media (min-width: 768px) {
    width: 80%;
    margin: 0 auto;
    flex-direction: column;
    div {
      display: flex;
    }
  }
}
.requiredWarning {
  font-size: 14px;
  color: $pink;
  text-align: center;
}
.bankDetails {
  text-align: center;
}
.observation {
  color: $pink;
  text-align: center;
  font-size: 14px;
  a {
    color: $pink;
    text-decoration: underline;
  }
}
textarea {
  padding-right: 10px;
  resize: none;
}
.btn {
  text-transform: uppercase;
  font-weight: 500;
}
.dates {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  font-size: 14px;
  div {
    padding: 8px 15px;
    border-radius: 30px;
    background-color: rgba($purple, 0.1);
    color: $purple;
    margin: 5px;
    &:first-child {
      opacity: 0.6;
    }
  }
}
.keep-professional-text {
  margin-top: 10px;
  font-size: 14px;
  color: $purple;
  @media (min-width: 768px) {
    text-align: left;
    padding-left: 5px;
    border-left: 1px solid $purple;
  }
}
form {
  display: flex;
  flex-direction: column;
  align-items: center;
}
h3 {
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 10px;
  color: $pink;
  text-align: center;
}
.radio-group {
  label {
    opacity: 0.6;
    margin: 10px 0;
    border-radius: 100px;
    background-color: rgba($purple, 0.04);
    padding: 15px 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    color: $purple;
    text-align: center;
    cursor: pointer;
    small {
      font-weight: 400;
    }
    &::before {
      content: "";
      display: inline-block;
      min-width: 10px;
      min-height: 10px;
      border-radius: 100%;
      border: 2px solid $purple;
      margin-bottom: 5px;
    }
  }
  input {
    display: none;
    &:checked ~ label {
      opacity: 1;
      &::before {
        background-color: $purple;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Freshdesk/Absence/Cancellation/Why.vue